import { Input } from '@/components/input'
import { Label } from '@/components/label'
import { Switch } from '@/components/switch'
import { TableHead, TableRow } from '@/components/table'

import {
    useConnectionFilter,
    useSetConnectionFilterIncludeDeleted,
    useSetConnectionFilterText,
} from '@/state/connectionFilter'

interface Props {
    marketCode: string
}

export default function ConnectionTableFilter({ marketCode }: Props) {
    const connectionFilter = useConnectionFilter(marketCode)
    const setFilterText = useSetConnectionFilterText(marketCode)
    const setIncludeDeleted = useSetConnectionFilterIncludeDeleted(marketCode)

    return (
        <TableRow>
            <TableHead colSpan={5}>
                <div className="flex items-center gap-4">
                    <Label className="m-0">Filter</Label>
                    <Input
                        className="h-8 w-65"
                        value={connectionFilter.filterText}
                        onChange={e => setFilterText(e.target.value)}
                    />
                </div>
            </TableHead>
            <TableHead>
                <div className="flex items-center justify-end gap-4">
                    <Switch checked={connectionFilter.includeDeleted} onCheckedChange={setIncludeDeleted} />
                    <Label className="m-0">Include deleted</Label>
                </div>
            </TableHead>
        </TableRow>
    )
}
